import { types } from '../types/types';

const initialState = [];

export const clientReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.setClients:
			return action.payload;

		case types.cleanClients:
			return initialState;

		default:
			return state;
	}
};
